import React from "react";
import "./GridCard.scss"
import arrow from "../../assets/arrow-blck.svg"
const GridCard = ({ header, subheader, isLearnMore, cardColor = "blue", gridIcon }) => {
    return (
        <div className="GridCard">
            {gridIcon && <div className={`${cardColor === "green" ? "GridCard-green" : cardColor === "yellow" ? "GridCard-yellow" : "GridCard-blue"}`}>
                <img alt="" src={gridIcon} className="GridCard-Ico" />
            </div>}
            <div className="GridCard-header">
                {header}
            </div>
            <div className="GridCard-subheader">
                {subheader}
            </div>
            {isLearnMore && <div className="GridCard-learnmore">
                Learn more
                <img className="GridCard-learnmore-ico"
                    alt="" src={arrow} />

            </div>}
        </div>
    )
}
export default GridCard